import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate, useParams} from 'react-router-dom'

import {useResolveExternalAppointment} from '~/api/appointments'
import {Container} from '~/components/general/container/Container'
import {Loading} from '~/components/general/loading/Loading'
import {Typography} from '~/components/general/typography/Typography'

export const ExternalAppointmentRedirectPage = () => {
  const {t} = useTranslation<string>()
  const navigate = useNavigate()
  const {externalAppointmentId} = useParams<{externalAppointmentId: string}>()
  const {data, isError} = useResolveExternalAppointment(externalAppointmentId)

  useEffect(() => {
    if (!data) return
    navigate(`/app/appointments/${data.appointmentId}/${data.patientId}`, {
      replace: true,
    })
  }, [data, navigate])

  if (!externalAppointmentId || isError) {
    return (
      <Container direction="column" spacing={2}>
        <Typography size="xl">{t('Appointment not found')}</Typography>
      </Container>
    )
  }

  return (
    <Container>
      <Loading />
    </Container>
  )
}
